import { editIconSvg } from '../svg'
import EditCard from './edit-card'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { ButtonActionType, ButtonData, ButtonType } from 'src/model/button'
import {
  getCollectionList,
  patchCollectionLandingPageAction,
} from 'src/reducers/collection/action'
import AddCollection from './add-collection'
import URL from 'src/api/url'
import Axios from 'axios'
import { formatPrice } from '../../simple-box-wrapper-options/utils'

const DEFAULT_IMAGE =
  'https://cdn.minicoursegenerator.com/assets/landing-page-templates/thumbnails/Default.png'
const CDN_BASE_URL = 'https://cdn.minicoursegenerator.com/'

// ✅ Request cache için global değişken
let lastRequestId = null

const ensureHttps = url => {
  if (!url) return DEFAULT_IMAGE
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  return `${CDN_BASE_URL}${url.startsWith('/') ? url.substring(1) : url}`
}

const parseSortOption = sortOption => {
  const sortingColumn = sortOption.includes('created_date')
    ? 'createdAt'
    : 'collectionName'
  const asc = sortOption.endsWith('_asc')
  return { sortingColumn, asc }
}

const parseCollectionIds = collectionsList => {
  return collectionsList && collectionsList.trim()
    ? collectionsList
        .split(',')
        .map(id => id.trim())
        .filter(id => id !== '')
    : []
}

const createQuery = (search, sort, ids = []) => {
  return {
    ids,
  }
}

const createQueryAdd = (search, sort = []) => {
  const { sortingColumn, asc } = parseSortOption(sort)
  return {
    filterText: search,
    currentPage: 0,
    pageSize: 100,
    sortingColumn,
    asc,
  }
}

const fetchCollections = async query => {
  try {
    const response = await Axios.post(URL.COLLECTION_LIST_LOOKUP, query)
    const items = response.data?.data || []
    return items
  } catch (error) {
    console.error(
      'Learning path fetch error:',
      error.response?.data || error.message,
    )
    return []
  }
}

const renderCollectionItem = (collection, isEdit, priceTagActive) => {
  return `
  <div class="${
    isEdit ? 'collection-list-container' : 'collection-list-container-preview'
  }"
       data-collection-id="${collection.id}">
    <div class="collection-list-inner-container">
      <div class="collection-list-sections-container">
        <div class="collection-list-section">
          <div class="collection-list-image">
            <div>
              <img data-cover-key="collection:${collection.id}" src="${
                !collection.thumbnail || collection.thumbnail === ''
                  ? DEFAULT_IMAGE
                  : ensureHttps(collection.thumbnail)
              }"
                   alt="${collection.name || 'Learning path'}">
            </div>
          </div>
        </div>
        <div class="collection-list-title">
          <div class="section-text-header">
            <p>${collection.name || 'Untitled learning path'}</p>
          </div>
          <div class="section-text">
            ${collection.description || ''}
          </div>
          <div class="section-important">
            ${
              priceTagActive === true
                ? `<div class="section-price">
                     <p>${formatPrice(collection.price)}</p>
                   </div>`
                : ''
            }


            <div class="section-count">
              <p>${collection.courseCount || 0} courses</p>
            </div>
          </div>
        </div>
      </div>
      ${
        isEdit
          ? `
        <div class="collection-list-hover-button">
          <button class="edit-collection-list-button"
                  type="button"
                  onclick="editCollection('${collection.id}')">
            ${editIconSvg} Edit
          </button>
        </div>
      `
          : ''
      }
    </div>
  </div>
`
}

const createModalButtons = (dispatch, onSave, saveLabel = 'Save') => [
  new ButtonData(ButtonType.NORMAL, 'Cancel', ButtonActionType.NO, () =>
    dispatch(messageBoxHideAction()),
  ),
  new ButtonData(ButtonType.ACTION, saveLabel, ButtonActionType.YES, () => {
    onSave()
    dispatch(messageBoxHideAction())
  }),
]

const updateCollectionUI = (collectionId, updatedData) => {
  const collectionIndex = window.collectionsData.findIndex(
    c => c.id === collectionId,
  )

  if (collectionIndex === -1) return

  const updateValues = updatedData.landingPageSettings
    ? updatedData.landingPageSettings
    : updatedData

  const updatedCollection = {
    ...window.collectionsData[collectionIndex],
    ...updateValues,
  }

  window.collectionsData[collectionIndex] = updatedCollection

  const collectionElement = document.querySelector(
    `[data-collection-id="${collectionId}"]`,
  )
  if (!collectionElement) return

  const imageElement = collectionElement.querySelector('img')
  if (imageElement) {
    imageElement.src =
      updatedCollection.thumbnail === ''
        ? DEFAULT_IMAGE
        : ensureHttps(updatedCollection.thumbnail)
  }

  const descriptionElement = collectionElement.querySelector('.section-text')
  if (descriptionElement) {
    descriptionElement.textContent = updatedCollection.description || ''
  }
}

const findDynamicListElement = () => {
  const selection = window.editor.model.document.selection
  const selectedElement = selection.getSelectedElement()

  if (selectedElement && selectedElement.name === 'dynamicList') {
    return selectedElement
  }

  const root = window.editor.model.document.getRoot()
  for (const child of root.getChildren()) {
    if (child.name === 'dynamicList') {
      return child
    }
  }

  return null
}

const setupEditCollection = dispatch => {
  window.editCollection = function (collectionId) {
    const collection = (window.collectionsData || []).find(
      c => String(c.id) === String(collectionId),
    )
    if (!collection) return
    const currentCollection = collection
    window.courseUpdateData = {
      id: currentCollection.id,
      landingPageSettings: {
        thumbnail: currentCollection.thumbnail || '',
        description: currentCollection.description || '',
        priceTagActive: currentCollection.showPriceTag || false,
      },
    }

    const handleSave = () => {
      if (!window.courseUpdateData) return
      updateCollectionUI(currentCollection.id, window.courseUpdateData)
      const { id, landingPageSettings } = window.courseUpdateData

      dispatch(
        patchCollectionLandingPageAction(id, [
          { path: 'thumbnail', value: landingPageSettings.thumbnail },
          { path: 'description', value: landingPageSettings.description },
        ]),
      )
    }

    const handleDelete = () => {
      const dynamicList = findDynamicListElement()
      if (!dynamicList) {
        console.error('dynamicList element not found')
        return
      }

      const currentCollections = dynamicList.getAttribute('collections') || ''
      const collectionsArray = parseCollectionIds(currentCollections)

      const updatedCollections = collectionsArray.filter(
        id => id !== String(currentCollection.id),
      )

      lastRequestId = null
      window.collectionsData = window.collectionsData.filter(
        c => c.id !== currentCollection.id,
      )

      window.editor.model.change(writer => {
        writer.setAttribute(
          'collections',
          updatedCollections.join(','),
          dynamicList,
        )
        window.editor.editing.reconvertItem(dynamicList)
        window.editor.editing.view.forceRender()
      })

      // Close the modal
      dispatch(messageBoxHideAction())
    }

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: createModalButtons(dispatch, handleSave),
          title: `
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px; 
                        color: var(--mcg-dark, #002E47); font-family: Inter; font-size: 16px; 
                        font-weight: 400; line-height: 150%;">
              <Typography>Edit </Typography>
            </div>
          `,
          component: (
            <EditCard
              collection={collection}
              thumbnailUrl={currentCollection.thumbnail || ''}
              description={currentCollection.description || ''}
              priceTagActive={currentCollection.showPriceTag || false}
              onSave={settings => {
                window.courseUpdateData = {
                  id: currentCollection.id,
                  landingPageSettings: settings,
                }
              }}
              setImageURL={() => {}}
              onDeleteClick={handleDelete}
            />
          ),
          maxWidth: '680px',
        }),
      ),
    )
  }
}

const setupAddCollection = dispatch => {
  window.addCollection = function () {
    const dynamicList = findDynamicListElement()
    if (!dynamicList) {
      console.error('dynamicList element not found')
      return
    }

    const query = createQueryAdd('', 'created_date_desc')
    dispatch(getCollectionList(query))

    const currentCollections = dynamicList.getAttribute('collections') || ''

    const handleAdd = () => {
      const collectionId = window.selectedCollectionId
      if (!collectionId) return

      window.editor.model.change(writer => {
        const dynamicListCurrent = findDynamicListElement()
        const currentCollections =
          dynamicListCurrent.getAttribute('collections') || ''
        const collectionsArray = parseCollectionIds(currentCollections)

        if (collectionsArray.includes(String(collectionId))) {
          console.warn('Collection already added')
          return
        }

        collectionsArray.push(String(collectionId))

        writer.setAttribute(
          'collections',
          collectionsArray.join(','),
          dynamicListCurrent,
        )

        lastRequestId = null
        window.collectionsData = null

        window.editor.editing.reconvertItem(dynamicListCurrent)
        window.editor.editing.view.forceRender()
      })

      window.selectedCollectionId = null
    }

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: createModalButtons(dispatch, handleAdd, 'Add'),
          title: `
            <div style="display: flex; align-items: center; justify-content: center; gap: 8px; 
                        color: var(--mcg-dark, #002E47); font-family: Inter; font-size: 16px; 
                        font-weight: 400; line-height: 150%;">
              <Typography>Add learning path</Typography>
            </div>
          `,
          component: (
            <AddCollection
              currentCollections={currentCollections}
              onSave={collectionId => {
                window.selectedCollectionId = collectionId
              }}
            />
          ),
          maxWidth: '720px',
        }),
      ),
    )
  }
}

const CreateCollectionList = async (
  dispatch,
  isEdit,
  collectionsList,
  priceTagActive,
) => {
  const ids = parseCollectionIds(collectionsList)

  const requestId = [...ids].sort().join(',')

  if (lastRequestId === requestId && window.collectionsData) {
    return `     
      <div class="collection-list-wrapper">
        ${window.collectionsData
          .map(collection =>
            renderCollectionItem(collection, isEdit, priceTagActive),
          )
          .join('')}
        ${
          isEdit
            ? `
        <div class="collection-list-add-button" onclick="addCollection()">
          <div class="collection-add-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
              <path fill="#fff" d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2"/>
            </svg>
          </div>
          <div class="collection-add-button-title"><p>Add learning path</p></div>
        </div>
        `
            : ''
        }
      </div>
    `
  }

  lastRequestId = requestId

  const query = createQuery('', 'created_date_desc', ids)

  let apiCollections = []
  try {
    const fetchedCollections = await fetchCollections(query)

    const collectionMap = new Map(
      fetchedCollections.map(col => [String(col.id), col]),
    )

    apiCollections = ids
      .map(id => collectionMap.get(String(id)))
      .filter(col => col !== undefined)
  } catch (error) {
    console.error('Failed to fetch collections:', error)
  }

  window.collectionsData = apiCollections
  window.courseUpdateData = null

  setupEditCollection(dispatch)
  setupAddCollection(dispatch)

  return `     
    <div class="collection-list-wrapper">
      ${apiCollections
        .map(collection =>
          renderCollectionItem(collection, isEdit, priceTagActive),
        )
        .join('')}
      ${
        isEdit
          ? `
      <div class="collection-list-add-button" onclick="addCollection()">
        <div class="collection-add-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
            <path fill="#fff" d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2"/>
          </svg>
        </div>
        <div class="collection-add-button-title"><p>Add learning path</p></div>
      </div>
      `
          : ''
      }
    </div>
  `
}

export default CreateCollectionList
